import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewCashPage } from './merchant-overview-cash';

@NgModule({
  declarations: [
    MerchantOverviewCashPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewCashPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewCashPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-cash/merchant-overview-cash.module.ts